
HTMLElement.prototype.__a = function(animation, prefix = 'a--') {
    const animationName = `${prefix}${animation}`;

    this.addEventListener('animationend', (e) => {
        e.stopPropagation();
        this.classList.remove(`${prefix}animate`, animationName);
    }, {once: true});

    this.classList.add(`${prefix}animate`, animationName);
}
